import { render, staticRenderFns } from "./ClusterTab.vue?vue&type=template&id=53867598&"
import script from "./ClusterTab.vue?vue&type=script&lang=js&"
export * from "./ClusterTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports